import Http from 'services/Http';

class ChatFlowEntityType {
  async find(id) {
    const { data } = await Http.get(`/v1/chat-flow-entity-type/${id}`);
    return data.chatFlowEntityType;
  }

  async list() {
    const { data } = await Http.get(`/v1/chat-flow-entity-type`);
    return data;
  }

  async create(form) {
    const response = await Http.post(`/v1/chat-flow-entity-type`, form);
    return response.data.chatFlowEntityType;
  }

  async update(id, form) {
    const response = await Http.patch(`/v1/chat-flow-entity-type/${id}`, form);
    return response.data.chatFlowEntityType;
  }

  async destroy(id) {
    const { data } = await Http.delete(`/v1/chat-flow-entity-type/${id}`);
    return data;
  }
}

export default new ChatFlowEntityType();
